// extracted by mini-css-extract-plugin
export default {"root":"styles_root__kd4uH","content":"styles_content__DRYJC"};